'use strict';

var debounce = require('lodash/debounce');
var timeout;
module.exports = {
  widgets: function widgets() {
    var targets = 'yotpo-widget-instance';
    clearTimeout(timeout);
    // Wait until synchronous thread end
    window.refreshYotpoWidgets = debounce(function () {
      var _window$yotpo, _window$yotpo$refresh, _window$yotpoWidgetsC, _window$yotpoWidgetsC2;
      var $completeWidgets = $('.' + targets + '[data-yotpo-element-loaded=true]').toggleClass(targets, false);
      (_window$yotpo = window.yotpo) === null || _window$yotpo === void 0 || (_window$yotpo$refresh = _window$yotpo.refreshWidgets) === null || _window$yotpo$refresh === void 0 ? void 0 : _window$yotpo$refresh.call(_window$yotpo);
      (_window$yotpoWidgetsC = window.yotpoWidgetsContainer) === null || _window$yotpoWidgetsC === void 0 || (_window$yotpoWidgetsC2 = _window$yotpoWidgetsC.initWidgets) === null || _window$yotpoWidgetsC2 === void 0 ? void 0 : _window$yotpoWidgetsC2.call(_window$yotpoWidgetsC);
      timeout = setTimeout(function () {
        return $completeWidgets.toggleClass(targets, true);
      }, 100);
    }, 1000);
  }
};